var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":_vm.getDetail}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"14px","height":"16px"},attrs:{"src":require("@/assets/hideBox/detail.png"),"alt":""}}),_c('span',[_vm._v("查看详情")])])
}]

export { render, staticRenderFns }